import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import EditRoutes from '../../components/Dispatch/editRoutes';
import { fetchCustomerRoutes, fetchRoutes, saveRouteEdits, saveNewRoute } from '../../actions/dispatch_actions';
import { fetchActiveCustomers } from '../../actions/customers_actions';

const editRoutes = reduxForm({
  form: 'editRoutes',
})(EditRoutes);

const selector = formValueSelector('editRoutes');

function mapStateToProps(state) {
  const days = selector(state, 'days');
  return {
    days,

    routes: state.dispatch.routes,
    routesIsLoading: state.dispatch.routesIsLoading,
    routesError: state.dispatch.routesError,

    customerRoutes: state.dispatch.customerRoutes,
    customerRoutesIsLoading: state.dispatch.customerRoutesIsLoading,
    customerRoutesError: state.dispatch.customerRoutesError,

    savingRouteEdits: state.dispatch.savingRouteEdits,
    saveRouteEditsSuccessful: state.dispatch.saveRouteEditsSuccessful,
    saveRouteEditsFailure: state.dispatch.saveRouteEditsFailure,
    saveRouteEditsError: state.dispatch.saveRouteEditsError,

    allCustomers: state.customers.all,
    customersIsLoading: state.customers.isLoading,
    customersError: state.customers.error,
  };
}

export default connect(mapStateToProps, {
  fetchCustomerRoutes,
  fetchRoutes,
  saveRouteEdits,
  saveNewRoute,
  fetchActiveCustomers,
})(editRoutes);



// WEBPACK FOOTER //
// ./master/jsx/containers/Dispatch/editRoutes.jsx